'use strict'

import entry from './controllers/entry'
import file from './controllers/file'
import form from './controllers/form'
import head from './controllers/head'
import members from './controllers/members'
import navigation from './controllers/navigation'
import search from './controllers/search'
import select from './controllers/select'
import slide from './controllers/slide'

const controllers = {
  entry,
  file,
  form,
  head,
  members,
  navigation,
  search,
  select,
  slide,
}

function init() {
  try {
    if (CSS.supports('display:grid') === false) {
      throw new Error('Browser does not support CSS Grid')
    }
  } catch (e) {
    const warningDiv = document.createElement('div')
    warningDiv.style.cssText =
      'padding:30px;background:#fff;color:#000;font-size:125%;'
    warningDiv.dataset.nosnippet = true
    warningDiv.innerHTML =
      '<p>Den här webbläsaren stöds inte längre. Vänligen använd en annan eller uppgradera till en nyare version.</p><p>/ Sveriges Kommunikationsbyråer</p>'
    document.body.appendChild(warningDiv)

    console.error(e)
  }

  document.body.querySelectorAll('[data-controller]').forEach((el) => {
    try {
      new controllers[el.dataset.controller](
        el,
        JSON.parse(JSON.stringify(el.dataset)),
      )
    } catch (e) {
      console.error(e)
    }
  })
}

if (document.readyState !== 'loading') {
  init()
} else {
  document.addEventListener('DOMContentLoaded', init, true)
}
